var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsi-remarks-block",attrs:{"data-testid":"upsi-remarks-block"}},[_c('p',{staticClass:"upsi-remarks-block__label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"upsi-remarks-block__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }